import {
    Directive,
    effect,
    inject,
    Renderer2,
    signal,
    TemplateRef,
    ViewContainerRef,
} from '@angular/core';

@Directive({
    selector: '[qpxCmdkEmpty]',
})
export class QpxCmdkEmpty {
    //#region Dependency injection
    private readonly templateRef = inject(TemplateRef<unknown>);
    private readonly viewContainer = inject(ViewContainerRef);
    private readonly renderer = inject(Renderer2);
    //#endregion

    //#region State
    private readonly visible = signal(false);
    private readonly hasView = signal(false);
    //#endregion

    //#region Lifecycle hooks
    constructor() {
        effect(() => this.syncView(this.visible()));
    }
    //#endregion

    //#region Public methods
    public show(condition: boolean): void {
        this.visible.set(condition);
    }
    //#endregion

    //#region Private methods
    private syncView(visible: boolean): void {
        if (visible && !this.hasView()) {
            this.createView();
            return;
        }

        if (!visible && this.hasView()) {
            this.viewContainer.clear();
            this.hasView.set(false);
        }
    }

    private createView(): void {
        const view = this.viewContainer.createEmbeddedView(this.templateRef);
        const firstRootNode = view.rootNodes[0] as Element | undefined;
        if (firstRootNode) {
            this.renderer.addClass(firstRootNode, 'qpx-cmdk-empty');
        }
        this.hasView.set(true);
    }
    //#endregion
}
